// ReadAloud.js
import React, { useState, useRef, useEffect } from "react";
import { Box, Button, LinearProgress } from "@mui/material";

const ReadAloud = ({ content }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [progress, setProgress] = useState(0);
  const utteranceRef = useRef(null);

  useEffect(() => {
    if (utteranceRef.current) {
      speechSynthesis.cancel();
      setIsPlaying(false);
      setProgress(0);
      utteranceRef.current = null;
    }
  }, [content]);

  const togglePlayback = () => {
    if (isPlaying) {
      speechSynthesis.cancel(); // cancel instead of pause
      utteranceRef.current = null; // reset reference
    } else {
      speechSynthesis.resume();
    }
    setIsPlaying(!isPlaying);
  };

  const readAloud = () => {
    if (utteranceRef.current) {
      togglePlayback();
      return;
    }
  
    const utterance = new SpeechSynthesisUtterance(content);
    utteranceRef.current = utterance;
  
    utterance.onstart = () => setIsPlaying(true);
    utterance.onpause = () => setIsPlaying(false);
    utterance.onresume = () => setIsPlaying(true);
    utterance.onend = () => {
      setIsPlaying(false);
      setProgress(0);
      utteranceRef.current = null;
    };
    utterance.onboundary = (e) => {
      const percentage = (e.charIndex / content.length) * 100;
      setProgress(percentage);
    };
  
    speechSynthesis.speak(utterance);
  };  

  return (
    <Box mt={2} textAlign={"right"}>
      <Button variant="contained" color="primary" onClick={readAloud}>
        {isPlaying ? "Cancel" : "Read Aloud"}
      </Button>
      <Box mt={2}>
        <LinearProgress variant="determinate" value={progress} />
      </Box>
    </Box>
  );
};

export default ReadAloud;
